import { useMemo } from 'react';

import { SIDEBAR_ITEMS, ROUTES } from 'shared/constants';
import { useGetFormattedSettings } from 'shared/hooks/useGetFormattedSettings';
import { useAccessibleAccounts } from 'shared/providers/AccessibleAccounts';

export const useSidebarItems = () => {
  const { reEnrolment } = useGetFormattedSettings();
  const { paymentRoutesDisabled } = useAccessibleAccounts();

  return useMemo(
    () =>
      SIDEBAR_ITEMS.map(item => ({
        ...item,
        endAdornment: reEnrolment?.hasPendingContracts ? item.endAdornment : undefined
      })).filter(item =>
        item.to === ROUTES.RE_ENROLMENT
          ? (reEnrolment?.isEnabled || paymentRoutesDisabled) && item
          : item
      ),
    [reEnrolment, paymentRoutesDisabled]
  );
};
